// extracted by mini-css-extract-plugin
export default {"docs_card":"Document_docs_card__pVw4u","card_img":"Document_card_img__KBCcz","row":"Document_row__H1j1Q","col":"Document_col__CPrJC"};